let idCounter = 0;

export const nextSelectId = () => {
  idCounter += 1;
  return `base-select-${idCounter}`;
};

export const findOptionByValue = (options, value) => (
  options.find((option) => option.value === value)
);

export const filterOptions = (options, query) => {
  if (!query) return options;
  const lowerQuery = query.toLowerCase();

  return options.filter((option) => {
    if (!option.name) return false;
    const name = option.name.toLowerCase();
    const search = option.search?.toLowerCase() ?? '';
    return name.includes(lowerQuery) || search.includes(lowerQuery);
  });
};

export const isOptionVisible = (option) => option?.show === undefined || option.show;
